import type { Nullish } from "~/@types/generics"
import { OPTIONS_PARAM, PANEL_SIZE_AUTO_OPEN_PARAM } from "~/components/ui/Product/ProductHeader/_data/constants"
import { applySearchParams } from "~/utils/apply-searchparams"

export function addPanelSizeAutoOpenParamURLToHref(href: string, existingOptionsParams: Nullish<string>) {
  const searchParams = new URLSearchParams()

  searchParams.set(PANEL_SIZE_AUTO_OPEN_PARAM, "1")

  if (existingOptionsParams) {
    searchParams.set(OPTIONS_PARAM, existingOptionsParams)
  }

  return applySearchParams(href, searchParams)?.replaceAll("%2C", ",")
}
